import { isMobileOnly } from 'react-device-detect';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { ParticipantsIcon } from '@icons';
import { colors } from '@constants/colors';
import ParticipantNumberInfo from './ParticipantsContent/ParticipantNumberInfo';
import IconPopover from '@core/dashboard/components/IconPopover';
import {
  Header,
  ModalContainer,
  Tabs,
} from '@core/dashboard/components/PopoverModal';
import ParticipantsContent from './ParticipantsContent';

const Participants = ({ t: translate }: WithTranslation) => {
  const getHeader = (onClose: any) => {
    if (isMobileOnly) {
      return (
        <>
          <Header
            text={translate('participantsModal.title')}
            onClose={onClose}
            isBig
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: `1px solid ${colors.silver}`,
            }}
          >
            <Tabs
              active={'hub'}
              tabs={[
                { label: translate('participantsModal.hub'), value: 'hub' },
              ]}
              onChange={() => {}}
            />
            <ParticipantNumberInfo />
          </Box>
        </>
      );
    } else {
      return (
        <>
          <Header
            text={translate('participantsModal.title')}
            onClose={onClose}
            isBig
          />
          <Tabs
            active={'hub'}
            tabs={[{ label: translate('participantsModal.hub'), value: 'hub' }]}
            onChange={() => {}}
          />
        </>
      );
    }
  };

  return (
    <IconPopover
      icon={<ParticipantsIcon />}
      label={translate('participantsModal.tooltip')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName="participants"
    >
      {({ onClose }) => (
        <ModalContainer isScrollable={false} header={getHeader(onClose)}>
          <ParticipantsContent onClose={onClose} />
        </ModalContainer>
      )}
    </IconPopover>
  );
};

export default withTranslation()(Participants);
